import { fork, takeEvery, takeLatest, select, put, putResolve } from "redux-saga/effects";
import { ChatSuggestionActions, filterSuggestionListAction, showSuggestionAction, querySuggestionListAction } from "../actions/chat-suggestion-actions";
import { ReqSuggestionHit } from "../types/chat-suggestion-types";
import { toQuerySuggestionApi, getSessionId } from "../common/api";
import { reSetChatMsgResultAction } from "../actions/chat-msg-actions";
import { ConversationSessionResp } from "../types/chat-msg-types";
import { SESSION_ID } from "../common/config";

function* querySuggestionList(payload?: any) {
    let resp;
    const suggestionHitReq: ReqSuggestionHit = {
        "prompts": payload.payload,
    }
    resp = yield toQuerySuggestionApi(suggestionHitReq)
    if (resp && resp.status === "success") {
        yield put(showSuggestionAction(true, resp.data));
        // yield put(showSuggestionAction(true, resp.data.slice(0,5)));
        yield put(filterSuggestionListAction(true, payload.payload));
    }else if (resp && resp.status === 401) {
        //reset chatMas
        yield putResolve(reSetChatMsgResultAction());
        //when detectIntent return 401,to get a new session again,and then detectIntent
        const resp: ConversationSessionResp = yield getSessionId();
        if (resp && resp.conversationSessionId) {
            sessionStorage.setItem(SESSION_ID, resp.conversationSessionId);
            yield put(querySuggestionListAction(payload.payload));
        }
    }
}

function* mySaga() {
    yield takeLatest(ChatSuggestionActions.QUERY_SUGGESTION_LIST, querySuggestionList);
}

const chatSuggestionSaga = [fork(mySaga)];

export default chatSuggestionSaga;